import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectsFacade, decrypt } from '@piqet-angular/data';
import { iconConfigsArr } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-data-quality-assessment-dropdown',
  templateUrl: './data-quality-assessment-dropdown.component.html',
  styleUrls: ['./data-quality-assessment-dropdown.component.css'],
})
export class DataQualityAssessmentDropdownComponent {
  params: any;
  processId: any;
  processList = [];
  bindLabel = '';
  bindValue = 'id';
  placeHolder = 'Process *';
  technologyComment = '';
  customWidth: any;
  technoRating: any;
  temporalRating: any;
  geographyRating: any;
  isSelected = true;
  createDiv: any;
  iconConfigs = iconConfigsArr;
  valueS: any;
  matchCircle: any;
  constructor(
    private route: ActivatedRoute,
    private admin: AdministratorService,
    private projectService: ProjectsService,
    private taoster: ToastrService,
    private projectFacade: ProjectsFacade
  ) {}

  agInit(params: any): void {
    this.params = params;
    const { value } = params;
    this.valueS = value;

    this.technoRating = this.params?.technoRating;
    this.temporalRating = this.params?.temporalRating;
    this.processId = params.data.technology;
    this.processList = params?.technologyList;
    this.bindLabel = 'name';
    this.placeHolder = 'Technology';
    this.customWidth = 450;

    switch (this.params.from) {
      case 'technology':
        this.technologyComment = params.data.technologyComment;
        this.matchCircle = params?.data?.technoRating;
        break;
      case 'Temporal':
        this.matchCircle = params?.data?.temporalRating;
        this.technologyComment = params.data.temporalComment;
        break;
      case 'geography':
        this.matchCircle = params?.data?.geographyRating;
        this.technologyComment = params.data.geographyComment;
        break;

      default:
        break;
    }
  }

  updateValue(event: any) {
    if (!!event?.id || !!Number(event?.idStr)) {
      this.params.data = { ...this.params.data };
      this.params.data.technologyName = event?.name;
      this.params.data['technologyId'] = event?.id;
      this.params.data['isCheckUpdateDropDown'] = true;
      this.params.editData(this.params.data);
    }
  }

  resetTValue() {
    this.params.data = { ...this.params.data };
    this.params.data.technologyName = 'null';
    this.params.data['technologyId'] = 0;
    this.params.data['isCheckUpdateDropDown'] = true;
    this.params.editData(this.params.data);
  }

  commonInputSearchForName(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  handleIconClick(event: MouseEvent, iconValue: string): void {
    const id = (event.target as HTMLElement).id;
    const clickedIconId = id.split('-')[1];
    switch (this.params.from) {
      case 'technology':
        this.iconConfigs.forEach((config: any) => {
          const iconElement = document.getElementById(
            `dataAssessmentQualityTechnology${this.params.from}${this.params.rowIndex}-${config.value}`
          );
          if (iconElement) {
            if (config.value == clickedIconId) {
              iconElement.className = 'cursor-pointer pointer-event fa fa-circle';
              iconElement.style.color = config.color;
              this.technoRating = clickedIconId;
              this.params.data = { ...this.params.data };
              this.params.data['technoRating'] = this.technoRating;
              this.params.editData(this.params.data);
            } else {
              iconElement.className = 'cursor-pointer pointer-event fa fa-circle-thin';
              iconElement.style.color = config.color;
              this.technoRating = clickedIconId;
              this.params.data = { ...this.params.data };
              this.params.data['technoRating'] = this.technoRating;
              this.params.editData(this.params.data);
            }
          }
        });
        break;
      case 'Temporal':
        this.iconConfigs.forEach((config: any) => {
          const iconElement = document.getElementById(
            `dataAssessmentQualityTechnology${this.params.from}${this.params.rowIndex}-${config.value}`
          );
          if (iconElement) {
            if (config.value == clickedIconId) {
              iconElement.className = 'cursor-pointer pointer-event fa fa-circle';
              iconElement.style.color = config.color;
              this.temporalRating = clickedIconId;
              this.params.data = { ...this.params.data };
              this.params.data['temporalRating'] = this.temporalRating;
              this.params.editData(this.params.data);
            } else {
              iconElement.className = 'cursor-pointer pointer-event fa fa-circle-thin';
              iconElement.style.color = config.color;
              this.temporalRating = clickedIconId;
              this.params.data = { ...this.params.data };
              this.params.data['temporalRating'] = this.temporalRating;
              this.params.editData(this.params.data);
            }
          }
        });
        break;
      case 'geography':
        this.iconConfigs.forEach((config: any) => {
          const iconElement = document.getElementById(
            `dataAssessmentQualityTechnology${this.params.from}${this.params.rowIndex}-${config.value}`
          );
          if (iconElement) {
            if (config.value == clickedIconId) {
              iconElement.className = 'cursor-pointer pointer-event fa fa-circle';
              iconElement.style.color = config.color;
              this.geographyRating = clickedIconId;
              this.params.data = { ...this.params.data };
              this.params.data['geographyRating'] = this.geographyRating;
              this.params.editData(this.params.data);
            } else {
              iconElement.className = 'cursor-pointer pointer-event fa fa-circle-thin';
              iconElement.style.color = config.color;
              this.geographyRating = clickedIconId;
              this.params.data = { ...this.params.data };
              this.params.data['geographyRating'] = this.geographyRating;
              this.params.editData(this.params.data);
            }
          }
        });
        break;

      default:
        break;
    }
  }

  blurDataQuality(event: any, type: string) {
    const value = event.value.trim();
    this.params.data = { ...this.params.data };
    switch (this.params.from) {
      case 'technology':
        if (value == '') {
          this.params.data['isCheckTechnology'] = true;
        }
        this.params.data['technologyComment'] = value;
        break;
      case 'Temporal':
        if (value == '') {
          this.params.data['isCheckTemporal'] = true;
        }
        this.params.data['temporalComment'] = value;
        break;
      case 'geography':
        if (value == '') {
          this.params.data['isCheckGeography'] = true;
        }
        this.params.data['geographyComment'] = value;
        break;
      default:
        break;
    }
    this.params.editData(this.params.data);
  }

  blurOut() {
    this.isSelected = false;
  }

  focusOn() {
    this.isSelected = true;
  }
}
